import colors from '../colors'

export default `
  #nprogress {
    pointer-events: none;
  }

  #nprogress .bar {
    background: ${colors.Primary.yellow500};
    position: absolute;
    z-index: 1000;
    top: -1px;
    left: 0;
    width: 100%;
    height: 3px;
  }

  .nprogress-custom-parent {
    overflow: hidden;
    position: relative;
  }

  .nprogress-custom-parent #nprogress .bar {
    position: absolute;
  }
`
